'use strict';



const $ = require('jquery');
const keycode = require('keycode');
const $input = $('.js-multi-email-input');



(function() {

	if($input.length < 1) {
		return;
	}

	$input.on('keyup change', e => {

		const newValue = $input.val()
			.replace(/(,| )+/g, '\n')
			.replace(/\n{2,}/, '\n');

		$input.val(newValue);

	});

})();